import { NOTICE_ATTACH_MAX_COUNT, NOTICE_ATTACH_MAX_COUNT_MESSAGE, NOTICE_ATTACH_MAX_SIZE, NOTICE_ATTACH_MAX_SIZE_MESSAGE } from "src/constants/notice";

export type NoticeAttachPick = { ok: true; files: File[] } | { ok: false; message: string };

/**
 * 공지 첨부로 고른 파일을 받아들일지 판정한다.
 *
 * 판정을 전부 끝낸 뒤에만 파일을 돌려준다. 예전 FileUpload 의 루프는 파일을 하나씩
 * 검사하면서 그 자리에서 목록에 담고 상한을 넘는 파일을 만나면 return 했다. 그래서
 * 3개 중 2번째가 상한을 넘으면 1번째는 이미 담긴 채로 3번째는 조용히 사라졌다.
 * 사용자는 초과 안내만 보고 목록이 어긋난 것은 알 수 없었다.
 *
 * 따라서 한 건이라도 상한을 넘으면 아무것도 담지 않는다. 받아들이거나 전부 거절하거나
 * 둘 중 하나다.
 */
export const pickNoticeAttachments = (currentCount: number, incoming: File[]): NoticeAttachPick => {
  if (currentCount + incoming.length > NOTICE_ATTACH_MAX_COUNT) {
    return { ok: false, message: NOTICE_ATTACH_MAX_COUNT_MESSAGE };
  }
  if (incoming.some((file) => file.size > NOTICE_ATTACH_MAX_SIZE)) {
    return { ok: false, message: NOTICE_ATTACH_MAX_SIZE_MESSAGE };
  }
  return { ok: true, files: incoming };
};

export default pickNoticeAttachments;
